import CheckboxSwitcher from './CheckboxSwitcher';

export default CheckboxSwitcher;



// WEBPACK FOOTER //
// ./src/components/common/CheckboxSwitcher/index.js